export default "__VITE_ASSET__CfHLXm3c__"